import { createFileRoute } from '@tanstack/react-router'

import WriteAdminKotaKabPage from '@/components/pages/backoffice/_user/_kabupaten/containers/WriteAdminKotaKab'

export const Route = createFileRoute('/_backoffice/user/kabupaten/create')({
  component: WriteAdminKotaKabPage
})
